import { AppEnv } from 'core/enums';
import { APP_ENV, DOMAIN_URL } from 'global';
import { BASE_ROUTE } from 'router/constants';

export const goTo = (url: string, newWindow = false) => {
  if (newWindow) {
    window.open(url, '_blank');

    return;
  }

  window.location.assign(url);
};

const SAFE_EXTERNAL_PROTOCOLS = ['http:', 'https:'];

// External URLs can come from company-configured templates: anything but an absolute http(s)
// URL (javascript:, data:, relative) must never be opened.
export const isSafeExternalUrl = (url: string | null | undefined): boolean => {
  if (!url) {
    return false;
  }

  try {
    return SAFE_EXTERNAL_PROTOCOLS.includes(new URL(url).protocol);
  } catch {
    return false;
  }
};

// noopener: the external page gets no window.opener to redirect this tab with.
export const openExternalUrl = (url: string) => {
  if (!isSafeExternalUrl(url)) {
    return;
  }

  window.open(url, '_blank', 'noopener,noreferrer');
};

export const getDomainHost = () => {
  if (APP_ENV === AppEnv.DEVELOPMENT) {
    const regex = new RegExp('https://([^/]+)');

    return regex.exec(DOMAIN_URL)[1];
  }

  return window.location.host;
};

export const getDomainUrl = () => {
  if (APP_ENV === AppEnv.DEVELOPMENT) {
    return DOMAIN_URL;
  }

  return window.location.origin;
};

export const getFullUrl = (path: string) => {
  const domainUrl = getDomainUrl();

  return `${domainUrl}${BASE_ROUTE}${path}`;
};
